import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.is-array";
import "core-js/modules/es.array.map";
import React from 'react';
import PropTypes from 'prop-types';
import CmsContent from '../../CmsContent';
import { getClasses } from '../../../../lib/style-utils/style-utils';
import styles from './Footnotes.less';

var FootnoteContent = function FootnoteContent(_ref) {
  var content = _ref.content;
  return /*#__PURE__*/React.createElement("ol", {
    className: getClasses({
      styles: styles,
      classes: ['cms_numbered_footnotes']
    })
  }, content && Array.isArray(content) && content.length ? content.map(function (footnote, i) {
    var _footnote$component = footnote.component,
        id = _footnote$component.id,
        text = _footnote$component.content.text;
    return text && /*#__PURE__*/React.createElement("li", {
      key: "".concat(id, "_").concat(i),
      id: "cms_footnote_".concat(id)
    }, /*#__PURE__*/React.createElement(CmsContent, {
      content: text
    }));
  }) : null);
};

FootnoteContent.propTypes = {
  content: PropTypes.array.isRequired
};
export default FootnoteContent;